import React from 'react';
import {
  LayoutDashboard,
  ShoppingCart,
  Users,
  Share2,
  TrendingUp,
  Activity,
} from 'lucide-react';

const menuItems = [
  { id: 'dashboard', label: 'Дашборд', icon: LayoutDashboard },
  { id: 'orders', label: 'Ордера', icon: ShoppingCart },
  { id: 'users', label: 'Пользователи', icon: Users },
  { id: 'referrals', label: 'Рефералы', icon: Share2 },
  { id: 'rates', label: 'Курсы', icon: TrendingUp },
  { id: 'events', label: 'События', icon: Activity },
];

export default function Sidebar({ currentScreen, onNavigate, adminUser, isOpen, onToggle }) {
  return (
    <aside
      className={`
        fixed top-0 left-0 h-full w-64 bg-gray-900 border-r border-gray-700/50
        flex flex-col z-40 transition-transform duration-200
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        md:translate-x-0
      `}
    >
      <div className="p-5 border-b border-gray-700/50">
        <h1 className="text-lg font-bold text-white">Kit8 Admin</h1>
        <p className="text-xs text-gray-500 mt-1">Dashboard v1.0</p>
      </div>

      <nav className="flex-1 py-4 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = currentScreen === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`
                w-full flex items-center gap-3 px-5 py-3 text-sm font-medium
                transition-colors duration-150
                ${active
                  ? 'bg-purple-500/20 text-purple-400 border-r-2 border-purple-400'
                  : 'text-gray-400 hover:text-white hover:bg-gray-800/50'
                }
              `}
            >
              <Icon size={18} />
              {item.label}
            </button>
          );
        })}
      </nav>

      {adminUser && (
        <div className="p-4 border-t border-gray-700/50">
          <div className="flex items-center gap-3">
            {adminUser.photoUrl ? (
              <img
                src={adminUser.photoUrl}
                alt=""
                className="w-8 h-8 rounded-full border-2 border-purple-500/30"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-400 text-sm font-bold">
                {(adminUser.firstName || 'A')[0]}
              </div>
            )}
            <div className="overflow-hidden">
              <p className="text-sm text-white font-medium truncate">
                {adminUser.firstName} {adminUser.lastName || ''}
              </p>
              {adminUser.username && (
                <p className="text-xs text-gray-500 truncate">@{adminUser.username}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
